import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
    GridRow, GridColumn, Grid,
    Table, Tab, Button, Icon, Checkbox,
    Segment,
    Input,
    Label,
    Loader,
    Dimmer,
    Item,
    Visibility,
} from 'semantic-ui-react';
var moment = require('moment');
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { WhatsappListAction, GetVendedoresRelatorioAction } from '../../actions/WhatsappActions';

import React from 'react'
import { Dropdown } from 'semantic-ui-react'
// import { getVendedoresRelatorio } from '../../../../api-server/modules/whatsappdb';

const options = [
    { key: 'm', text: 'Male', value: 'male' },
    { key: 'f', text: 'Female', value: 'female' },
    { key: 'o', text: 'Other', value: 'other' },
]



const StyledTable = styled(Table)`
  &&& {
    border-spacing: 0px;
    margin-bottom: 0px;
    padding: 0px 0px;
  }
`;

const StyledTableHeader = styled(Table.Header)`
  &&& th {
    padding: 0px;
    margin: 0px 0px 0px 0px;
  }
`;

const StyledTableBody = styled(Table.Body)`
  &&& td {
    padding: 0px 0px !important;
    margin: 0px 0px 0px 0px !important;
  }
`;


function Relatorio(props) {


    const [checkedItems, setCheckedItems] = useState({});
    const [checkedItems2, setCheckedItems2] = useState({});
    const [isLoadingList, setLoadingList] = useState(true);

    const [vendedorDropdown, setVendedorDropdown] = useState(null);

    const [activeIndex, setActiveIndex] = useState(0);


    const [dadosFilter, setFilteredData] = useState([]);

    const debounceTimeoutRef = useRef(null); //time para filtrar

    const { GetVendedoresRelatorioAction, GetVendedoresRelatorio, vendedoresRelatorio, vendedoresRelatorioLoader, WhatsappListAction, codvend } = props;
    const [searchTerm, setSearchTerm] = useState('');
    console.log(codvend);


    const filtrarVendedores = (valorBusca, dadosCompletos) => {

        if (!dadosCompletos || !Array.isArray(dadosCompletos)) {
            return [];
        }

        if (!valorBusca || valorBusca.trim() === '') {
            return dadosCompletos;
        }

        const termo = valorBusca.toLowerCase().trim();

        return dadosCompletos.filter(item =>
            String(item?.codvend || '').toLowerCase().includes(termo) ||
            String(item?.apelido || '').toLowerCase().includes(termo)
        );

    }

    // useEffect(() => {
    //     console.log('vendedoresRelatorio:', vendedoresRelatorio);
    //     console.log('Tipo:', typeof vendedoresRelatorio);
    //     console.log('É array?', Array.isArray(vendedoresRelatorio));
    //     console.log('Tamanho:', vendedoresRelatorio?.length);
    // }, [vendedoresRelatorio]);


    useEffect(() => {

        const filtrados = filtrarVendedores(searchTerm, vendedoresRelatorio);
        setFilteredData(filtrados);
        console.log('Total', vendedoresRelatorio?.length, 'Filtrados', filtrados.length);

    }, [searchTerm, vendedoresRelatorio]);



    const handleSearchChange = (e) => {
        const valor = e.target.value;

        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            setSearchTerm(valor);
        }, 500);
    };

    useEffect(() => {
        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (codvend) {

            GetVendedoresRelatorioAction({
                codvend: Number(codvend),
                dadosFilter: dadosFilter || null
            });
        }
    }, [props.active]);



    

    // useEffect(() => {
    //     if (codvend) {

    //         GetVendedoresRelatorioAction({
    //             codvend: Number(codvend),
    //             dadosFilter: dadosFilter || null
    //         });
    //     }
    // }, [codvend, dadosFilter]);




    function search() {
        console.log('Busca front-end ativa com termo:', searchTerm);

    }




    return (
        <Tab.Pane
            activeIndex={activeIndex}
            onTabChange={(e, { activeIndex }) => setActiveIndex(activeIndex)}>

            <Label style={{ background: 'transparent' }} loa>
                CodVend / Apelido:
                <Input
                    style={{ height: '40px', marginLeft: '10px', width: '250px', border: '1px solid #1884af', borderRadius: '10px' }}
                    placeholder='Cod Vendedor / Apelido'
                    icon='search'
                    onChange={handleSearchChange}
                >

                </Input>
            </Label>

            {searchTerm && (
                <Label style={{ marginLeft: '10px', background: '#1884af', color: 'white' }}>
                    {dadosFilter.length} resultado(s) encontrado(s)
                </Label>
            )}


            {vendedoresRelatorioLoader ? (
                <Segment style={{
                    border: 'none',
                    minHeight: '5em',
                }}>
                    <Dimmer active inverted Style={{ display: 'block' }}>
                        <Loader active inline='centered' />
                    </Dimmer>
                </Segment>
            ) : (
                <StyledTable celled id="listVendedores" compact='very' size='small' >
                    <StyledTableHeader>
                        <Table.Row >
                            <Table.HeaderCell width="1">Cod Vendedor</Table.HeaderCell>
                            <Table.HeaderCell width="4">Vendedor</Table.HeaderCell>
                            <Table.HeaderCell width="1">Quantidade de clientes</Table.HeaderCell>
                            <Table.HeaderCell width="1">Clientes com WhatsApp</Table.HeaderCell>
                            <Table.HeaderCell width="1">Clientes sem WhatsApp</Table.HeaderCell>
                            <Table.HeaderCell width="1">Clientes com Email</Table.HeaderCell>
                            <Table.HeaderCell width="1">Clientes sem Email</Table.HeaderCell>

                        </Table.Row>
                    </StyledTableHeader>


                    {dadosFilter.map((item) => (
                        <Table.Row key={`parceiro-${item.codvend}`} className='trContent'>
                            <Table.Cell className='relatorioCell'>{item.codvend}</Table.Cell>
                            <Table.Cell className='relatorioCell'>{item.apelido}</Table.Cell>
                            <Table.Cell className='relatorioCell'>{item.parc_total_qtd}</Table.Cell>
                            <Table.Cell className='relatorioCell' style={{ color: 'green' }}>{item.qtd_parc_com_wts}</Table.Cell>
                            <Table.Cell className='relatorioCell' style={{ color: 'red' }}>{item.qtd_parc_sem_wts} - ( {item.parc_total_qtd == 0 ? 100 :((item.qtd_parc_sem_wts * 100)/item.parc_total_qtd).toFixed(1)}% )</Table.Cell>
                            <Table.Cell className='relatorioCell' style={{ color: 'green' }}>{item.qtd_parc_com_email}</Table.Cell>
                            <Table.Cell className='relatorioCell' style={{ color: 'red' }}>{item.qtd_parc_sem_email} - ( {item.parc_total_qtd == 0 ? 100 : ((item.qtd_parc_sem_email * 100)/item.parc_total_qtd).toFixed(1)}% )</Table.Cell>
                        </Table.Row>
                    ))}
                    {/* ) : (
                        <Table.Row>
                            <Table.Cell colSpan="7" style={{ textAlign: 'center', padding: '20px' }} className='trContent>
                                {searchTerm ? (
                                    <>
                                        <Icon name='search' size='large' />
                                        <p>Nenhum vendedor encontrado com o termo "{searchTerm}"</p>
                                    </>
                                ) : (
                                    <p>Nenhum vendedor encontrado</p>
                                )}
                            </Table.Cell>
                        </Table.Row>
                    )} */}

                    <StyledTableBody />
                </StyledTable>
            )}




            <style>{`

            .ui.celled.table tr th{
                    padding: 1em .5em !important;
                }
                table > .trContent{
                   line-height: auto !important;
                   padding: 0 .5em ;
                }

                .ui.celled.table tr td{
                    text-align: center;
                    padding: 0 .5em ;
                }


            .ui.active.modal{
                width: 80% !important;
            }

            .ui.segment{
                brackground-color: transparent !important;
                drop-shadow: none !important;
                box-shadow: none !important;
            }

                .ui.button.btnDel{
                    background-color: #1884AF !important;
                    color: white !important;
                }
                .ui.button.btnDel:hover{
                    background-color: #1884AF !important;
                    color: white !important;
                }

                .ui.celled.table tr .relatorioCell{
                    padding: .3em .2em !important;
                    text-align: center;
                }

                .edit.icon:hover{
                    color: #666 !important;
                    transition: .3s !important
                }
                .trash.icon:hover{
                    color: #666 !important;
                    transition: .3s !important
                }

                .infoBtn:hover>i.icon.info.circle{
                    color: #1884afc2 !important;
                    transition: .3s !important;
                }
                
                .ui.search.selection.upward.dropdown{
                    background-color: #1884af !important;
                    color: white !important;
                }
                .ui.selection.dropdown .menu>.item:hover{
                    background-color: #1884af3a !important;
                    transition: .3s !important;
                }

                .ui.table thead tr th{
                    padding: 0 .5em !important;
                    text-align: center !important;
                }


                //------------------------

                div.ui.compact.segment{
                width: 100%;
                    display: block !important;
                    border: none !important;
                    margin: 0 auto !important;
                }
                td div.ui.segment {
                    border: none !important;
                    padding: 0;
                    margin: 0 auto !important;
                    background-color: transparent !important;
                }
                
                .ui.toggle.checkbox label:before{
                    background: #979797;
                }

                

                //------------------------

                button.ui.button.btnConfirm:hover{
                    background-color: #236623 !important;
                    color: black !important;
                    transition: .3s !important;
                }
                .btnCancel:hover{
                    background-color: #8a0d0d !important;
                    transition: .3s !important;
                }


                .cellModalCtt input[type=email], 
                .cellModalCtt input[type=password], 
                .cellModalCtt input[type=search], 
                .cellModalCtt input[type=text] {
                    width: 100% !important;
                }


                .ui.grid>.row>[class*="three wide"].column .ui.form .inline.fields .field {
                    paddign: 0 !important;
                    width:'100%' !important;
                }

                .dtfimTrue.ui.compact.segment, 
                .dtfimFalse.ui.compact.segment{
                    background: transparent !important;
                    border:none !important;
                    box-shadow: 0px 0px 0px white !important.
                }

                //------------------------

                .ui.active.centered.inline.loader{
                    height: 3em
                }

                //------------------------
          
            
            `}</style>

        </Tab.Pane >
    )
};


const mapStateToProps = (state) => ({
    vendedoresList: state.WhatsappReducer.vendedoresList,
    userid: state.LoginReducer.userid,
    codvend: state.LoginReducer.vendedorvcc,
    vendedoresLoader: state.WhatsappReducer.vendedoresLoader,


    vendedoresRelatorio: state.WhatsappReducer.vendedoresRelatorio,
    vendedoresRelatorioLoader: state.WhatsappReducer.vendedoresRelatorioLoader


})

export default withRouter(connect(mapStateToProps, {

    GetVendedoresRelatorioAction
})(Relatorio));

